// Multiple distribution centers are not supported — the active one is environment-specific.
export const distributionCenterId = process.env.NEXT_PUBLIC_DISTRIBUTION_CENTER_ID ?? '1'